import React, { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookies_accepted')) setShow(true);
  }, []);

  if (!show) return null;

  const accept = () => {
    localStorage.setItem('cookies_accepted', 'true');
    setShow(false);
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: '#111', color: 'white',
      padding: '14px 20px', display: 'flex',
      gap: 12, alignItems: 'center',
      flexWrap: 'wrap', zIndex: 99999
    }}>
      <p style={{ margin: 0, flex: 1, fontSize: 13, lineHeight: 1.5 }}>
        We use cookies to keep you logged in and improve the app.{' '}
        <a href="/privacy" style={{ color: '#C8102E' }}>Privacy Policy</a>
      </p>
      <button
        onClick={accept}
        style={{
          background: '#C8102E', color: 'white', border: 'none',
          padding: '8px 24px', borderRadius: 20, fontWeight: 700,
          fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap'
        }}
      >
        Got it
      </button>
    </div>
  );
}